import { createApp } from 'vue';
import { createPinia, mapWritableState } from 'pinia'
import { useConsultantsStore } from '../../components/consultants/store.js';

const pinia = createPinia()

if (document.getElementById('consultant-program-details-page')) {
    const app = createApp({
        data() {
            return {
              fields: [
                {
                  key: 'name',
                  label: 'Name',
                  sortable: true,
                  'class': 'name'
                },
                {
                  key: 'email',
                  label: 'Email',
                  sortable: false,
                  'class': 'email'
                },
                {
                  key: 'phone',
                  label: 'Phone',
                  'class': 'phone'
                },
                {
                  key: 'additional_contact_info',
                  label: 'Additional Contact Info',
                  'class': 'additional'
                },
                {
                  key: 'edit',
                  label: 'Action',
                  'class': 'edit'
                }
              ],
            };
          },
        methods: {
            getProgramUsers() {
                axios('/api/program-users/' + this.programId)
                    .then(function (response) {
                        this.users = response.data;
                    }.bind(this))
                    .catch(function (error) {
                        console.error(error);
                    })
            },
            getProgramId() {
                var url = window.location.pathname;
                this.programId = url.substr(url.lastIndexOf('/') + 1);
            },
            showModal(user) {
                this.email = user.email
                this.phone = user.phone
                this.additional = user.additional_contact_info
                this.userId = user.id
                this.successMessage = []
                this.errors = []
            },
        },
        computed: {
            ...mapWritableState(useConsultantsStore, {
                userId: 'userId',
                programId: 'programId',
                users: 'users',
                email: 'email',
                phone: 'phone',
                additional: 'additional',
                successMessage: 'successMessage',
            }),
        },
        mounted: function () {
            this.getProgramId()
            this.getProgramUsers()
        }
    });
    app.use(pinia);
    app.mount('#consultant-program-details-page');
}

if (document.getElementById('program-user-contact-form-modal')) {
    const app2 = createApp({
        data() {
            return {
              errors: [],
            };
          },
        methods: {
            validate: function (e) {
                // console.log(this.user)
                this.errors = [];
                if (!this.email) this.errors.push('Email is required.')
                if (!this.errors.length) {
                    this.submit();
                }
            },
            submit() {
                
                axios.post('/api/program-users/edit', {
                    id: this.userId,
                    program_id: this.programId,
                    email: this.email,
                    phone: this.phone,
                    additional: this.additional

                })
                    .then(function (response) {
                        this.getProgramUsers()
                        this.closeModal('content-modal')
                        this.clearForm();
                        this.successMessage.push('Sucessfully edited contact info')
                    }.bind(this))
                    .catch(function (error) {
                        console.error(error);
                    })
            },
            getProgramUsers() {
                axios('/api/program-users/' + this.programId)
                    .then(function (response) {
                        this.users = response.data;
                    }.bind(this))
                    .catch(function (error) {
                        console.error(error);
                    })
            },
            clearForm() {
                this.email = null
                this.phone = null
                this.additional = null
                this.userId = null
            },
            showModal(user) {
                this.email = user.email
                this.phone = user.phone
                this.additional = user.additional_contact_info
                this.userId = user.id
                this.successMessage = []
                this.errors = []
            },
            hideModal() {
                this.clearForm()
            },
            closeModal(modalId) {
                const modal = document.getElementById(modalId);
                modal.classList.remove('show');
                modal.setAttribute('aria-hidden', 'true');

                const modalBackdrop = document.querySelector('.modal-backdrop');
                if (modalBackdrop) {
                    modalBackdrop.remove();
                }

                document.body.classList.remove('modal-open');
            },
        },
        computed: {
            ...mapWritableState(useConsultantsStore, [
                'userId',
                'programId',
                'users',
                'email',
                'phone',
                'additional',
                'successMessage',
            ]),
        },
    });
    app2.use(pinia);
    app2.mount('#program-user-contact-form-modal');
}
